import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as StartupDashBoardActions from "src/app/core/state/startup-dashboard";
import { getStartupProfileCompleteness, rasingFundRequestFault, rasingFundRequestSuccess } from 'src/app/core/state/startup-dashboard';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { ToastAlertService } from '../../utils/toast.service';
import { Router } from '@angular/router';
import { getStartUpInfo } from 'src/app/core/state/startup';
import { IStartUpInfoFetch } from 'src/app/core/domain/startup.model';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { getProfileData } from 'src/app/core/state/profile';
import { createSlug, getMissingFieldsMap } from 'src/app/shared/utils/common-methods';
import { IBrandDetails } from 'src/app/core/domain/brand.model';
import { getBrandDetails } from 'src/app/core/state/global';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShareProfileModalComponent } from '../share-profile-modal/share-profile-modal.component';
import { getTitleFromNavLink, MissingFormKeyToUrlMapping } from '../../constants/constants';

@Component({
  selector: 'app-startup-raise-fund-switch',
  templateUrl: './startup-raise-fund-switch.component.html',
  styleUrls: ['./startup-raise-fund-switch.component.scss']
})
export class StartupRaiseFundSwitchComponent implements OnInit, OnDestroy {
  @Input() isUnderApproval = false;
  private destroyed$: Subject<void> = new Subject();
  missingFields: Array<any> = [];
  profileCompleteness;
  profileCompletenessPercentage = 0;
  canRequestApproval = false;
  public getProfileData$: Observable<IProfileDetails>;
  profileData: IProfileDetails;

  @Input() hideMissingFields = false;
  startupInfo: IStartUpInfoFetch;
  public startupInfo$: Observable<IStartUpInfoFetch>;
  public startupProfilePageUrl: string = "";
  brandDetails: Partial<IBrandDetails>;
  @Input() showShareFeedback = true;
  @Input() showEditProfileBtn = true;


  constructor(
    private readonly store: Store,
    private toastAlertService: ToastAlertService,
    private router: Router,
    public modal: NgbModal,
  ) {
    this.startupInfo$ = this.store.pipe(select(getStartUpInfo));
    this.getProfileData$ = this.store.pipe(select(getProfileData));
  }

  ngOnInit(): void {

    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.brandDetails = res
      }
    })

    this.getProfileData$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) {
        this.profileData = res;
      }
    })

    this.startupInfo$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res: any) => {
      if (res) {
        this.startupInfo = res;
        this.startupProfilePageUrl = `/startups/profile/${this.startupInfo.uuid}/${createSlug(this.startupInfo.companyName)}`;
        console.log(this.startupProfilePageUrl);
      }
    });

    this.store.dispatch(new StartupDashBoardActions.GetProfileCompleteness());
    this.store.pipe(select(getStartupProfileCompleteness)).pipe(takeUntil(this.destroyed$)).subscribe((res: any) => {
      if (res) {
        this.profileCompleteness = res;
        this.profileCompletenessPercentage = res?.percentage || 0;

        this.canRequestApproval = res?.canRequestApproval || false;
        this.profileCompleteness = res;
        this.isUnderApproval = this.profileCompleteness && this.profileCompleteness?.isApprovalRequested && !this.profileCompleteness?.canToggleStatus && !this.profileCompleteness?.isApproved;

        this.getMissingFields();
      }
    });

    this.store.pipe(select(rasingFundRequestSuccess)).pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if (res) {
        this.toastAlertService.showToast(res);
      }
    })

    this.store.pipe(select(rasingFundRequestFault)).pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if (res) {
        this.toastAlertService.showToast(res, 'error');
      }
    })
  }


  getMissingFields = () => {
    this.missingFields = getMissingFieldsMap(this.profileCompleteness, 'startups')
  }

  onToggleChange($event) {
    this.store.dispatch(new StartupDashBoardActions.RasingFundRequest);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  handleShareButton() {
    this.modal.open(
      ShareProfileModalComponent, { centered: true, size: 'lg' }
    )
  }

  get isProfileCompleted() {
    return this.profileCompleteness?.percentage >= 100 && this.profileCompleteness?.isApproved;
  }

  get isEditProfileDisabled() {
    const backdoorLogin = localStorage.getItem('logged-in-from-backdoor');
    return this.brandDetails?.features?.disable_startup_profile_update && backdoorLogin !== 'true' && this.profileCompleteness?.approvalStatus === 'submitted'
  }

  get isLimitedAccess() {
    return this.profileCompleteness?.isRejected && this.brandDetails?.features?.limited_access && this.profileCompleteness?.approvalStatus === 'limited_access'
  }

  get editProfileVisible() {
    return this.profileCompleteness?.percentage < 100 && !this.hideMissingFields && this.showEditProfileBtn && !this.isUnderApproval
  }

}
